import clsx from "clsx";

export default function Title({ className, children }) {
  return (
    <div className={clsx(className + " font-bold tracking-widest text-6xl text-center lg:text-left")}>
      {children}
    </div>
  );
}
